import { ICellRendererParams } from 'ag-grid-community'
import React, { useEffect, useState } from 'react'
import { RootDiv } from '../../../commons/AgGrid/components/cell/CellRendererRoot'
import { getLabel } from '../../../../../lib/commons/i18nLabel'
import { FloatingEditableIcon } from '../../../commons/AgGrid/components/cell/common/text'
import {
  CustomEnumValue,
  FunctionProperty,
} from '../../../../../lib/commons/appFunction'
import Tooltip from '../../../../components/tooltips/Tooltip'
import { setError } from '../../lib/validation'
import { WbsItemStatus } from '../../../../../domain/entity/WbsItemEntity'
import { WbsItemStatusMarker } from '../../../../features/WbsItemStatusChip'
import { CustomEnumCode } from '../../../../../lib/functions/customEnumValue'
import { inputErrorColor } from '../../../commons/AgGrid/lib/validator'

type Props = ICellRendererParams & {
  customEnumCode?: string
  valuesAllowed?: CustomEnumValue[]
  uiMeta?: FunctionProperty
}

// サブステータスに紐づくステータスは、カスタム列挙の組合せ定義(WBS_STATUS)として保持されている。
// 複数ステータスに紐づく定義も許容されるため、代表として先頭を●の色に使う。
const getLinkedStatus = (
  option: CustomEnumValue | undefined
): WbsItemStatus | undefined => {
  const linkedValue = option?.combinations?.find(
    combination => combination.combinedEnumCode === CustomEnumCode.WBS_STATUS
  )?.combinedValues?.[0]?.value
  return linkedValue ? WbsItemStatus[linkedValue] : undefined
}

// サブステータス列のセル。ガントチャートと同様に、紐づくステータスを色●で示す。
export const SubStatusCellRenderer = (props: Props) => {
  const {
    context,
    value,
    data,
    valueFormatted,
    customEnumCode,
    valuesAllowed,
    uiMeta,
  } = props
  const [message, setMessage] = useState<string | undefined>()

  useEffect(() => {
    if (uiMeta?.requiredIf) {
      const result = uiMeta.requiredIf.check(value, () => ({}))
      const err = result.ok ? undefined : result.message
      setError(data, err, props)
      setMessage(err)
    }
  }, [value])

  const options: CustomEnumValue[] | undefined = customEnumCode
    ? context[customEnumCode]
    : valuesAllowed
  const option: CustomEnumValue | undefined = options?.find(
    option => option.value === value
  )
  const linkedStatus = getLinkedStatus(option)

  return (
    <Tooltip message={message}>
      <RootDiv
        style={{
          backgroundColor: !!message ? inputErrorColor : undefined,
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        {option && linkedStatus && (
          <WbsItemStatusMarker status={linkedStatus} />
        )}
        {option && (valueFormatted ?? getLabel(option.nameI18n) ?? option.name)}
        <FloatingEditableIcon {...props} />
      </RootDiv>
    </Tooltip>
  )
}
